import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "../styles/Nav.css";

const Nav = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    // Scroll to the section by id
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Scroll to the top when Home is clicked
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        closeMenu();
    };

    // Trigger scroll after navigating to the homepage
    useEffect(() => {
        // If we navigated to the home page and there's an id in the URL (like "#what-we-automate")
        if (location.pathname === "/" && location.hash) {
            scrollToSection(location.hash.substring(1)); // Remove '#' to get the id
        }
    }, [location]);

    const handleScrollTo = (sectionId) => {
        if (location.pathname !== "/") {
            navigate("/");

            setTimeout(() => {
                scrollToSection(sectionId);
            }, 300);
        } else {
            scrollToSection(sectionId);
        }

        closeMenu();
    };

    return (
        <nav className="navbar">
            <div className="nav-logo">
                <NavLink to="/" onClick={scrollToTop}>
                    <img src="/logo.png" alt="Brand Bounce Logo" className="logo" />
                    <img src="/logo-text.png" alt="Brand Bounce" className="logo" />
                </NavLink>
            </div>

            <ul className={`nav-links ${isMenuOpen ? "mobile-show" : ""}`}>
                <li>
                    <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                        onClick={scrollToTop}
                    >
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/#what-we-automate"
                        className="nav-scroll-link"
                        onClick={() => handleScrollTo("what-we-automate")}
                    >
                        Products
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/#how-it-works"
                        className="nav-scroll-link"
                        onClick={() => handleScrollTo("how-it-works")}
                    >
                        How It Works
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/resources"
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                        onClick={closeMenu}
                    >
                        Resources
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/contact"
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                        onClick={closeMenu}
                    >
                        Contact
                    </NavLink>
                </li>
            </ul>

            <div className="nav-cta">
                <NavLink to="/contact" className="cta-button" onClick={closeMenu}>
                    Book a Free Call
                </NavLink>
            </div>

            <div
                className={`hamburger ${isMenuOpen ? "active" : ""}`}
                onClick={toggleMenu}
            >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
            </div>
        </nav>
    );
};

export default Nav;
